module.exports = __webpack_public_path__ + "img/pendle-eth-lp.3a473790.svg";